import Cookies from 'js-cookie';

export const getToken = (): string | undefined => Cookies.get('sid');
// TODO: What's this here for? Why isn't it being used?
export const setToken = (token?: string | null): undefined => {
  if (!token) return;

  Cookies.set('sid', token);
};

export const clearToken = (sid: string): void => Cookies.remove(sid);
